export class EnhancedError extends Error {
	id?: string;
	constructor(message: string, id?: string) {
		super(message);
		Object.setPrototypeOf(this, EnhancedError.prototype);

		this.id = id;
	}
}
